export const emDash = '\u2014';
